import { IconButton, Tooltip } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const DashboardLockButton = () => {

    const handleLock = () => {
        const savedTheme =
        localStorage.getItem('fuseSelectedTheme');
        sessionStorage.removeItem('dashboard_unlocked');
        localStorage.clear();
        if (savedTheme) {
            localStorage.setItem(
                'fuseSelectedTheme',
                savedTheme
            );
        }
        window.location.reload();
    };

    return (
        <Tooltip title="Lock Dashboard">
            <IconButton
                onClick={handleLock}
                sx={{
                    position: 'fixed',
                    bottom: 24,
                    right: 26,
                    zIndex: 9999,
                    backgroundColor: 'secondary.main',
                    color: 'secondary.contrastText',
                    width: 38,
                    height: 38,
                    boxShadow: '0px 4px 20px rgba(0,0,0,0.5)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        backgroundColor: 'secondary.dark',
                        transform: 'scale(1.1)'
                    }
                }}
            >
                <LockOutlinedIcon fontSize="medium" />
            </IconButton>
        </Tooltip>
    );
};

export default DashboardLockButton;